import { excludeArchivedPlans } from '@/widgets/pricing/pricingCards/lib/utils/excludeArchivedPlans';
import { excludePlanByCategory } from '@/widgets/pricing/pricingCards/lib/utils/excludePlanByCategory';
import { getTransformedPlans } from '@/widgets/pricing/pricingCards/lib/utils/getTransformedPlans';

import { useProducts } from '@/entities/pricing';

import { PlanCategory } from '@/shared/types/Billing';

const NOT_BILLING_PLANS = new Set([PlanCategory.Enterprise, PlanCategory.Starter]);

type UseBillingOptions = {
  showErrors?: boolean;
};

export const useBilling = ({ showErrors = true }: UseBillingOptions = {}) => {
  const { availableProducts: products, error } = useProducts(true, { showErrors });

  const billingPlans = excludePlanByCategory(products?.plan ?? [], NOT_BILLING_PLANS);
  const activePlans = excludeArchivedPlans(billingPlans);
  const plansGroupByCategory = getTransformedPlans(activePlans);

  return {
    error,
    plansGroupByCategory,
    products,
  };
};
